import CaptionsPlugin from 'paella-core/js/captions/CaptionsPlugin';

export default class TestCaptionsPlugin extends CaptionsPlugin {

}
